import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { useCallback } from 'react';
import { EffectRegistrationEvaluationTimeOptionsClient } from 'requests/nswag/nllMedicineTasks/NllMedicineTasksClient';

function useFetchEvaluationTimeOffsets(customerId: string): UseQueryResult<number[]> {
  const getEvaluationTimeOffsets = useCallback(() => {
    const client = new EffectRegistrationEvaluationTimeOptionsClient();
    return client.getEvaluationTimeOffsets(customerId);
  }, [customerId]);

  return useQuery({ queryKey: ['EVALUATION_TIME_OFFSETS', customerId], queryFn: getEvaluationTimeOffsets });
}

export default useFetchEvaluationTimeOffsets;
